<template>
    <div style="width:100%; box-sizing: border-box;">
    <GrcDB ref="GRCDB"></GrcDB>    
    <GrcDialog ref="Dialog"></GrcDialog>


      <div style="width:100%; box-sizing: border-box; text-align: left;">
        <h2 class="painted_header_h2 color3"><span style="color:inherit; font-weight:500;">Számla feltöltés</span></h2>
        <br><br>

          <div class="infotext1" v-html="Leiras"></div>
          

          
          <div class="szla_cont">
            <div class="szla_header">Számla</div>
            <GrcDocMultiSelect ref="szladocs" :grc_maxfiles="MaxFiles" :grc_allowed_extensions="AllowedExtensions" grc_shownoti="false "/>
          </div>

          <div class="szla_cont">
            <div class="szla_header">Orvosi dokumentum</div>
            <GrcDocMultiSelect ref="orvosidocs" :grc_maxfiles="MaxFiles" :grc_allowed_extensions="AllowedExtensions" grc_shownoti="false "/>
          </div>

            <GrcTextArea ref="txtMegjegyzes"
            grc_labeltext="Megjegyzés:" grc_labelmode="above" grc_labelwidth="200px" 
            grc_areaheight="150px"
            style="margin-top:10px;"
            />

          <div style="width:100%; box-sizing:border-box; text-align:center; margin: 20px 0px 10px 0px;">
            <GrcBankszla ref="txtBankszamlaszam" v-model="txtBankszamlaszam"
            grc_labeltext="Bankszámlaszám, amire az utalást kérem:"
            grc_placeholder=""
            grc_labelmode="above" grc_labelwidth="300px" 
            grc_readonly="false"
            v-on:grc-keydown-enter="SetControlToFocus('');"
            style="width:100%; max-width:400px; display:inline-block;"
            />
          </div>


            <div class="btncont" style="text-align: center; margin: 30px 0px 10px 0px;">

                <span @click="btnOK_click" class="painted_linkbutton2 color3" style="margin: 4px 0px;">
                    <span><i class="fal fa-check" style="margin-right: 4px;"></i>Számla beküldése</span>
                </span>                                        

            </div>



          


        </div>


    </div>
</template>

<script>

import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcDocMultiSelect from '../GrcComponents/GrcDocMultiSelect.vue'
import GrcBankszla from '../GrcComponents/GrcBankszla.vue'
import GrcTextArea from '../GrcComponents/GrcTextArea.vue'

export default {
  name: 'frmszamlaFeltoltes',
  components: {
      GrcDB,
      GrcDialog,
      GrcDocMultiSelect,
      GrcBankszla,
      GrcTextArea,
  },
  props: {

  },
  data () {
      return {
          WSPREFIX: "frmSzamlaFeltoltes_",

          KarID:0,
          Leiras:"",
          txtBankszamlaszam:"",

          MaxFiles:"-1",
          AllowedExtensions:"pdf, jpg, png",
      }
  },
  model: {

  },  
  methods:{

    SetLang()
    {
      this.Init();
    },


      SetControlToFocus(pNextComp)
      {
        this.$refs[pNextComp].SetFocus();
      },



      btnOK_click(e)
      {
        this.Mentes();
      },

      async Init()
      {
        this.Files = [];

        this.$refs.GRCDB.ShowLoading(false);

        var QP = { 
            sSessionID: "[APPSESSIONID]",
            iKarID: this.KarID,
        };


        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Init", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();

            document.location = "dashboard";
            return;
        }

        this.$refs.GRCDB.HideLoading();

        if (Q.RESULT.length == 0)
        {
            document.location = "dashboard";
            return;
        }

        if (Q.RESULT[0].SzamlaEngedely == 0)
        {
            document.location = "dashboard";
            return;
        }

        this.$refs.txtBankszamlaszam.SetText(Q.RESULT[0].Bankszamlaszam);

        this.Leiras = Q.RESULT[0].Leiras;

      },


      async Mentes()
      {
        this.$refs.GRCDB.ShowLoading(false);

        var pUploadID1 = ""; 
        var pUploadID2 = ""; 

        var UploadRes = await this.$refs.szladocs.UploadFiles(1);

        if (UploadRes.FileCount == 0) 
        { 
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("Legalább egy számla fájl megadása kötelező!", 200);
          return;
        }

        if (UploadRes.UploadID == "")
        { 
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("A számla feltöltés előkészítése sikertelen!", 200);
          return;
        }

        if (UploadRes.Success == false)
        {
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("A számla feltöltés előkészítése sikertelen!", 200);
          return;
        }

        pUploadID1 = UploadRes.UploadID;


        UploadRes = await this.$refs.orvosidocs.UploadFiles(1);

        if (UploadRes.FileCount == 0) 
        { 
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("Legalább egy orvosi dokumentum fájl megadása kötelező!", 200);
          return;
        }

        if (UploadRes.UploadID == "")
        { 
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("Az orvosi dokumentum feltöltés előkészítése sikertelen!", 200);
          return;
        }

        if (UploadRes.Success == false)
        {
          this.$refs.GRCDB.HideLoading();
          this.ShowInfo("Az orvosi dokumentum feltöltés előkészítése sikertelen!", 200);
          return;
        }

        pUploadID2 = UploadRes.UploadID;


        var QP = { 
            sSessionID: "[APPSESSIONID]",
            sUploadID1: pUploadID1,
            sUploadID2: pUploadID2,
            sMegjegyzes: this.$refs.txtMegjegyzes.GetText().trim(),
            sBankszamlaszam: this.$refs.txtBankszamlaszam.GetText(),
            iKarID: this.KarID,
        };

        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX + "Save", QP).then(res => { Q = res; });

        
        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            this.ShowInfo(Q.APPERR[0].ERR, 200);
            return;
        }

        this.$refs.GRCDB.HideLoading();


        var strRes = 'Az adatok mentése sikeresen megtörtént!<br><br><b>Azonosító:</b><br>'+Q.RESULT[0].Iktatoszam;

        await this.ShowInfo(strRes, 200);

        document.location = "dashboard";

      },

    async ShowInfo(pText, pHeight)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = 400;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },
  created()
  {

  },
  mounted()
  {

    this.KarID = 0;

    if (GRCAPP_GetParameters.hasOwnProperty("KARID"))
    {
        try
        {
            this.KarID = parseInt(GRCAPP_GetParameters.KARID);
        } catch
        {
            this.KarID = 0;
        }
    }

    if (this.KarID == 0)
    {
        document.location = "dashboard";
        return;
    }


    this.SetLang();

  }

}


</script>


<style scoped>

.szla_cont
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:14px;
  line-height: 18px;
  color:#444;
  padding:8px;
  border: solid 1px #ccc;
  border-radius: 0px;  
  margin:10px 0px;
  background-color: rgba(200,200,200,0.2)
}


.szla_header
{
  font-family: 'CmsDefault';
  font-size:18px;
  line-height: 24px;
  color:var(--themecolor3);
  padding:0px;
  font-weight: 500;
  width:100%;
  box-sizing: border-box;
  text-align: left;
}

.szla_delicon
{
  font-size:16px;
  line-height: 16px;
  padding:0px;
  font-family: 'CmsDefault';
  width:30px;
  text-align: center;
  padding:4px 0px;

    background-color: hotpink;
    color: #fff;
    border-radius: 2px;  
}

.szla_delicon:hover
{
    background-color: deeppink;
    cursor:pointer;
}

.btncont
{
  width:100%;
  box-sizing: border-box;
  text-align: center;
}


.btn
{
  display: inline-block;
  font-size: 13px;
  line-height: 16px;
  font-family: 'CmsDefault';
  font-weight: normal;
  text-align: center;  
  background-color:var(--premblue);
  color:#fff;
  padding:8px 8px;
  cursor:pointer;
  border-radius: 2px;
  margin: 2px;
  min-width: 120px;

}

.btn:hover
{
  background-color: var(--premgreen);
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
    background-color: #ddd;
    color: #444;;
}

.btn_gray:hover
{
    background-color: var(--premgreen);
    color: #fff;;
}

.infotext1
{
  width:100%;
  box-sizing: border-box;
  font-family: 'CmsDefault';
  font-size:16px;
  line-height: 22px;
  color:#000;
  padding:8px 0px;
  font-weight: 500;
  margin-bottom:0px;

}





@media (max-width:670px)
{

}

</style>